import _styled from"@emotion/styled";const IconContainer=_styled.div`
  ${{"display":"inline-block","height":"2.25rem","width":"2rem"}}

  &:before {
    ${{"display":"inline-block","height":"100%","width":"100%","borderRadius":"0.5rem","backgroundSize":"contain","backgroundRepeat":"no-repeat"}}
    content: '';
    background-image: ${props=>`url('${props.icon}')`};
  }
`;export default IconContainer;